import { useIsSmUp } from '@/shared/lib/style/breakpoints'

/**
 * Custom hook that provides consistent modal configurations
 * based on screen size for responsive behavior
 */
export function useResponsiveModal() {
  const isSmUp = useIsSmUp()

  return {
    isSmUp,
    size: isSmUp ? 'xl' : 'auto',
    fullScreen: !isSmUp,
    transitionProps: {
      transition: isSmUp ? 'fade' : 'slide-down',
      duration: isSmUp ? 120 : 180,
      exitDuration: isSmUp ? 120 : 180,
      timingFunction: 'ease-out',
    },
  } as const
}
